import React from 'react'
import classNames from 'classnames'
import { CircleCheckIcon } from '@/atoms/Icons/CircleCheckIcon'
import { AsDiv, AsSpan, CaptionSM, CaptionXS, HeadingLG, TitleSM, TitleXS } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { PromoPrice } from './form'
import { GuildGiftContext } from './state'
import { filterHighlightedFeatures } from './tiers'

interface PromoCardProps {
  className?: string
}

export function PromoCard({ className }: PromoCardProps) {
  const { state } = React.useContext(GuildGiftContext)
  const { t } = useTranslate('guild')

  return (
    <div
      className={classNames(
        'flex flex-col gap-2 rounded-2xl bg-core-gray-300 p-6 text-core-gray-950 shadow-lg md:mb-12 lg:mb-0',
        className,
      )}
    >
      <TitleXS weight="semibold" as={AsDiv} color="core-gray-700">
        {t('addSomeoneToYourAccount', 'Add someone to your account')}:
      </TitleXS>
      <div>
        <HeadingLG as={AsSpan} weight="bold" className="inline-flex gap-[14px]">
          <PromoPrice normalPrice={1200} promoPrice={600} />
        </HeadingLG>
        <TitleSM as={AsSpan} weight="bold">
          /{t('month', 'month')}
        </TitleSM>
      </div>

      <ul className="flex flex-col gap-2">
        {filterHighlightedFeatures(t, state.tier.name).map((feature, i) => (
          <li key={i} className="flex items-center gap-2">
            <CircleCheckIcon size={16} color1="black" className="shrink-0 grow-0" />
            <CaptionSM>{feature}</CaptionSM>
          </li>
        ))}
      </ul>
      <CaptionXS as={AsDiv} color="info-600" weight="semibold" className="pt-2">
        {t('noteMembershipAutoRenewV1', 'Membership will auto-renew unless canceled before end date. Cancel anytime.')}
      </CaptionXS>
    </div>
  )
}
